import clsx from "clsx";
import { format, set } from "date-fns";
import { useEffect, useState } from "react";
import { Dropdown, ProgressBar } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import ObservationsForm from "../../../components/Observations/ObservationsForm";
import OrdersSideCard from "../../../components/Order/OrdersSideCard";
import OrderItemRow from "../../../components/OrderItemRow";
import RenderStatus from "../../../components/RenderStatus";

import { useFeedBack } from "../../../context/FeedBackContext";
import useAxios from "../../../hooks/useAxios";
import { formatDate, safeFormatCLP } from "../../../util/format";
import { FaFilter, FaBoxes } from "react-icons/fa";


const OrdersDetails = () => {

    const { id } = useParams();

    const { setLoading } = useFeedBack();

    const [checkAllItems, setCheckAllItems] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);

    const [currentOrderDetails, setCurrentOrderDetails] = useState(null);

    const [orderItemFilters, setOrderItemFilters] = useState({
        name: '',
        product_code: '',
        provider_name: '',
        status_code: '',
        quantity_min: '',
        quantity_max: '',
        price_min: '',
        price_max: '',
        total_min: '',
        total_max: '',
        sent_min: '',
        sent_max: '',
        order_by: 'name,ASC',
        with: ['subjects']
    });

    const [{ data: orderDetails, loading: loadingOrderDetails }, getOrder] = useAxios({ url: `/orders/${id}` }, { useCache: false });

    const [{ data: orderItems, loading: loadingOrderItems }, getOrderItems] = useAxios({ url: `/orders/${id}/order-items`, params: orderItemFilters }, { useCache: false });

    const [{ data: orderItemsStatuses, loading: loadingOrderItemsStatuses }] = useAxios({ url: `/order-items/statuses` }, { useCache: false });

    const [{ data: updateStatusData, loading: updateStatusLoading }, updateStatus] = useAxios({ url: `/order-items/update-status/multiple`, method: 'POST' }, { manual: true, useCache: false });

    const [{ loading: loadingTotalOrderItemsQuantities, }, setTotalOrderItemsQuantities] = useAxios({ url: `/order-items/set-total-quantities`, method: 'POST' }, { manual: true, useCache: false });

    useEffect(() => {
        if (checkAllItems) {
            setSelectedItems(orderItems?.data?.map(item => item?.id));
        } else {
            setSelectedItems([]);
        }
    }, [checkAllItems]);

    useEffect(() => {
        if (updateStatusData) {
            setCurrentOrderDetails((oldOrderDetails) => {
                return {
                    ...oldOrderDetails,
                    ...updateStatusData?.data
                }
            })
        }
    }, [updateStatusData])

    useEffect(() => {
        if (orderDetails) {
            setCurrentOrderDetails((oldOrderDetails) => {
                return {
                    ...oldOrderDetails,
                    ...orderDetails?.data
                }
            });
        }
    }, [orderDetails]);

    useEffect(() => {
        setLoading?.({
            show: loadingOrderDetails,
            message: 'Obteniendo Información'
        })
    }, [loadingOrderDetails]);

    const handleSetOrderItemsStatuses = (orderItemStatus) => {

        if (updateStatusLoading) return;

        updateStatus({
            data: {
                itemsIds: selectedItems,
                status_code: orderItemStatus?.code
            }
        }).then((res) => {
            getOrderItems({ params: orderItemFilters });
            setSelectedItems([]);
            setCheckAllItems(false);
        })
    }

    const handleApplyTotalQuantitites = () => {
        setTotalOrderItemsQuantities({
            data: { itemIds: selectedItems }
        }).then(() => {
            getOrder();
            getOrderItems({ params: orderItemFilters });
            setSelectedItems([]);
            setCheckAllItems(false);
        });
    }

    return (
        <div>
            <div className="text-end my-4">
                <Link to="/pedidos" className="mx-4 btn btn-primary">
                    Volver Al listado
                </Link>
                <Link to="/pedidos/crear" className="mx-4 btn btn-primary">
                    Crear Nuevo
                </Link>
            </div>
            <h4 className="text-center">Progreso {currentOrderDetails?.orderStatus?.progress}%</h4>
            <ProgressBar
                now={currentOrderDetails?.orderStatus?.progress}
                variant={currentOrderDetails?.orderStatus?.variantColor}
                className="my-3"
            />
            <div className="row">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-4">
                                    <b>Número de Pedido</b>
                                    <p>{currentOrderDetails?.id}</p>
                                    <b>Servicio</b>
                                    <p style={{ textTransform: 'capitalize' }}>{currentOrderDetails?.service?.name || '--'}</p>
                                </div>
                                <div className="col-4">
                                    <b>Tipo</b>
                                    <p>{currentOrderDetails?.orderType?.displayText || '--'}</p>
                                    <b>¿Es para repuestos?</b>
                                    <p>{currentOrderDetails?.isReplacement ? 'SI' : 'NO'}</p>
                                </div>
                                <div className="col-4">
                                    <b>Fecha de Creación</b>
                                    {
                                        currentOrderDetails?.createdAt ?
                                            <p>{format(new Date(currentOrderDetails?.createdAt), 'dd/MM/yyyy hh:mm:ss a')}</p>
                                            :
                                            <p>--</p>
                                    }
                                    <b>Estatus</b>
                                    <RenderStatus hiddenBar styles={{ marginBottom: '10px' }} value={currentOrderDetails} />
                                </div>
                                <div className="col-md-4 my-4">
                                    <b>Gestionado Por:  </b>
                                    <br />
                                    {currentOrderDetails?.user?.name}
                                </div>
                                <div className="col-md-4 my-4">
                                    <b>Jefe de la zona:  </b>
                                    <br />
                                    {currentOrderDetails?.orderBoss?.name || '--'}
                                </div>
                                <div className="col-md-4 my-4">
                                    <b>Enc. de Adquisiciones:  </b>
                                    <br />
                                    {currentOrderDetails?.adquisicionUser?.name || '--'}
                                </div>
                                <div className="col-md-4 mb-4">
                                    <b>Fecha de aprobación:  </b>
                                    <br />
                                    {formatDate(currentOrderDetails?.approved_at)}
                                </div>
                                <div className="col-md-4 mb-4">
                                    <b>Cobro por Formular:  </b>
                                    <br />
                                    {
                                        currentOrderDetails?.feeForFormulating ?
                                            'SI'
                                            :
                                            'NO'
                                    }
                                </div>
                            </div>
                            {
                                currentOrderDetails?.feeForFormulating ?
                                    <div className="row">
                                        <div className="col-md-4">
                                            <b>Autorizado por:</b>
                                            <br />
                                            {currentOrderDetails?.authorizedBy || '--'}
                                        </div>
                                        <div className="col-md-4">
                                            <b>Cuenta:</b>
                                            <br />
                                            {currentOrderDetails?.account || '--'}
                                        </div>
                                        <div className="col-md-4">
                                            <b>Cebe:</b>
                                            <br />
                                            {currentOrderDetails?.seven || '--'}
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            <br />

                            <h3 className="text-center">Productos</h3>

                            <div className="alert alert-info text-center my-3">
                                Para ver la descripción del producto manual haga click en el icono del ojito.
                            </div>

                            <div className="table-responsive">
                                <table className="table text-center table-order-detail">
                                    <thead>
                                        <tr>
                                            <th>
                                                Acciones
                                            </th>
                                            <th>
                                                <div className="d-flex align-items-center gap-1">
                                                    <input type="checkbox" onChange={() => setCheckAllItems(old => !old)}
                                                        checked={checkAllItems}
                                                    />
                                                    #
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Cód.
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.product_code,
                                                                'text-dark': !orderItemFilters?.product_code
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Código"
                                                                value={orderItemFilters?.product_code}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, product_code: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Nombre
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.name,
                                                                'text-dark': !orderItemFilters?.name
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Nombre"
                                                                value={orderItemFilters?.name}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, name: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Prov.
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.provider_name,
                                                                'text-dark': !orderItemFilters?.provider_name
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Proveedor"
                                                                value={orderItemFilters?.provider_name}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, provider_name: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                Archivo
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Estatus
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.status_code,
                                                                'text-dark': !orderItemFilters?.status_code
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <select
                                                                className="form-control"
                                                                value={orderItemFilters?.status_id}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, status_code: e.target.value }))}
                                                            >
                                                                <option value="">Seleccione una opción</option>
                                                                {
                                                                    orderItemsStatuses?.data?.map((orderStatus, i) => {
                                                                        return (
                                                                            <option
                                                                                className="text-capitalize"
                                                                                value={orderStatus?.code}
                                                                                key={`order-item-status-option-${orderStatus?.code}`}
                                                                            >
                                                                                {orderStatus?.name}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Cant.
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.quantity_min || orderItemFilters?.quantity_max,
                                                                'text-dark': !orderItemFilters?.quantity_min && !orderItemFilters?.quantity_max
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control mb-2"
                                                                placeholder="Cant. Mínina"
                                                                value={orderItemFilters?.quantity_min}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, quantity_min: e.target.value }))}
                                                            />
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control"
                                                                placeholder="Cant. Máxima"
                                                                value={orderItemFilters?.quantity_max}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, quantity_max: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Cant. Enviada
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.sent_min || orderItemFilters?.sent_max,
                                                                'text-dark': !orderItemFilters?.sent_min && !orderItemFilters?.sent_max
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control mb-2"
                                                                placeholder="Cant. Mínina"
                                                                value={orderItemFilters?.sent_min}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, sent_min: e.target.value }))}
                                                            />
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control"
                                                                placeholder="Cant. Máxima"
                                                                value={orderItemFilters?.sent_max}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, sent_max: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    P.U.
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.price_min || orderItemFilters?.price_max,
                                                                'text-dark': !orderItemFilters?.price_min && !orderItemFilters?.price_max
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control mb-2"
                                                                placeholder="Precio Unitario Mínimo"
                                                                value={orderItemFilters?.price_min}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, price_min: e.target.value }))}
                                                            />
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control"
                                                                placeholder="Precio Unitario Máximo"
                                                                value={orderItemFilters?.price_max}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, price_max: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="d-flex justify-content-between align-items-center gap-1">
                                                    Total
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className={clsx("border-none bg-transparent border-0 p-1", {
                                                                "text-primary": orderItemFilters?.total_min || orderItemFilters?.total_max,
                                                                'text-dark': !orderItemFilters?.total_min && !orderItemFilters?.total_max
                                                            })}
                                                            size="sm"
                                                        >
                                                            <FaFilter />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ padding: 8, minWidth: 200 }}>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control mb-2"
                                                                placeholder="Precio Unitario Mínimo"
                                                                value={orderItemFilters?.total_min}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, total_min: e.target.value }))}
                                                            />
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control"
                                                                placeholder="Precio Unitario Máximo"
                                                                value={orderItemFilters?.total_max}
                                                                onChange={(e) => setOrderItemFilters(val => ({ ...val, total_max: e.target.value }))}
                                                            />
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            orderItems?.data?.map((item, i) => {
                                                return (
                                                    <OrderItemRow
                                                        getOrder={getOrder}
                                                        selectedItems={selectedItems}
                                                        setSelectedItems={setSelectedItems}
                                                        order={currentOrderDetails}
                                                        orderTypeId={currentOrderDetails?.orderTypeId}
                                                        orderItem={item}
                                                        key={i}
                                                        index={i}
                                                    />
                                                )
                                            })
                                        }
                                        <tr>
                                            <td colSpan={4}>
                                                <h3 style={{ margin: 0 }}>
                                                    Total
                                                </h3>
                                            </td>
                                            <td colSpan={6} className="text-end">
                                                <h3 style={{ margin: 0 }}>
                                                    {safeFormatCLP(Number(currentOrderDetails?.total))}
                                                </h3>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <ObservationsForm
                                defaultObservations={currentOrderDetails?.observations}
                                orderId={currentOrderDetails?.id}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <OrdersSideCard
                        order={currentOrderDetails}
                        orderStateFunct={setCurrentOrderDetails}
                    />
                </div>
            </div>
            {
                selectedItems.length > 0 ?
                    <div className="col-lg-6 col-12 px-5 px-md-0 position-fixed" style={{ bottom: 10, left: '50%', transform: 'translate(-50%, -10%)' }}>
                        <div className="rounded bg-white animate__animated animate__zoomIn  position-relative"
                            style={{ height: 'fit-content', boxShadow: "0 8px 24px #374d6326" }}>
                            <button
                                onClick={() => {
                                    setCheckAllItems(false);
                                    setSelectedItems([]);
                                }}
                                className="btn btn-danger rounded-circle"
                                style={{ position: 'absolute', top: -15, right: -15, fontSize: 24, height: 36, width: 36, padding: 0 }}
                            >
                                <i className="fa fa-times"></i>
                            </button>
                            <div className="d-flex align-items-center global-actions-container">
                                <div className="w-100 bg-primary rounded d-flex align-items-center justify-content-center h-100">
                                    {
                                        updateStatusLoading || loadingTotalOrderItemsQuantities ?
                                            <div className="spinner">
                                                <div className="double-bounce1 bg-white"></div>
                                                <div className="double-bounce2 bg-white"></div>
                                            </div>
                                            :
                                            <h1 className="text-white mb-0">
                                                {selectedItems.length}
                                            </h1>
                                    }
                                </div>
                                {
                                    orderItemsStatuses?.data?.map((orderItemStatus, i) => {
                                        return (
                                            <div className="w-100 rounded h-100" key={`aplicar-estado-a-item-${orderItemStatus?.code}`}>
                                                <button
                                                    disabled={updateStatusLoading || loadingTotalOrderItemsQuantities}
                                                    onClick={() => handleSetOrderItemsStatuses(orderItemStatus)}
                                                    className={`btn h-100 w-100 text-${orderItemStatus?.variantColor} d-flex align-items-center justify-content-center`}
                                                >
                                                    <div>
                                                        <p className="mb-0 text-uppercase w-100 text-center" style={{ fontSize: 14 }}>
                                                            {orderItemStatus?.name}
                                                        </p>
                                                    </div>
                                                </button>
                                            </div>
                                        )
                                    })
                                }
                                <div className="w-100 rounded h-100">
                                    <button
                                        disabled={updateStatusLoading || loadingTotalOrderItemsQuantities}
                                        onClick={handleApplyTotalQuantitites}
                                        className="btn h-100 w-100 text-primary d-flex align-items-center justify-content-center"
                                    >
                                        <div>
                                            <p className="mb-0 w-100 text-uppercase" style={{ fontSize: 14 }}>
                                                Aplicar totales
                                            </p>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }
        </div >
    )
}

export default OrdersDetails;